import React from 'react';
import s from './CollapseInfoItem.scss';
import classNames from 'classnames';
import {Cell} from '../../../../Layouts/Cell/Cell';
import {InfoSectionDescription} from '../../../InfoSectionDescription/InfoSectionDescription';
import {InfoSectionLayoutId, keyboardEvents} from '../../../../../constants';
import {InfoSectionTitle} from '../../../InfoSectionTitle/InfoSectionTitle';
import {MinusTabs, PlusTabs} from '../../../../../icons/dist';
import AnimateHeight from 'react-animate-height';

export enum DataHook {
  CollapseInfoItem = 'collapse-info-item',
  Button = 'collapse-info-button',
  MinusIcon = 'collapse-info-minus-icon',
  PlusIcon = 'collapse-info-plus-icon',
}

export interface CollapseInfoItemProps {
  description: string;
  index: number;
  title: string;
  isActive: boolean;

  handelToggleCollapse(index: number): void;
  onAnimationEnd(ref: React.RefObject<HTMLButtonElement>): void;
  enableRtlAlignment?: boolean;
}

export class CollapseInfoItem extends React.PureComponent<CollapseInfoItemProps> {
  private readonly collapseRef = React.createRef<HTMLButtonElement>();

  private readonly onToggleCollapse = () => {
    const {handelToggleCollapse, index} = this.props;
    handelToggleCollapse(index);
  };

  private readonly onKeypressToggleCollapse = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    /* istanbul ignore else: todo: test */
    if (e.keyCode === keyboardEvents.ENTER.keyCode) {
      this.onToggleCollapse();
    }
  };

  public render(): JSX.Element {
    const {description, title, isActive, index, onAnimationEnd, enableRtlAlignment} = this.props;
    const CollapseInfoItemClass = classNames(s.infoSectionCollapse, {[s.isActive]: isActive});
    return (
      <li className={CollapseInfoItemClass} data-hook={DataHook.CollapseInfoItem}>
        <button
          type="button"
          ref={this.collapseRef}
          className={classNames(s.button, enableRtlAlignment ? s.rtlAlignment : s.buttonWhenExperimentIsClosed)}
          aria-expanded={isActive}
          onClick={this.onToggleCollapse}
          onKeyPress={this.onKeypressToggleCollapse}
          data-hook={DataHook.Button}>
          <InfoSectionTitle theme={InfoSectionLayoutId.Collapse} title={title} />
          {isActive ? (
            <Cell
              className={classNames(s.icon, {[s.iconRtlAlignment]: enableRtlAlignment})}
              data-hook={DataHook.MinusIcon}>
              <MinusTabs />
            </Cell>
          ) : (
            <Cell
              className={classNames(s.icon, {[s.iconRtlAlignment]: enableRtlAlignment})}
              data-hook={DataHook.PlusIcon}>
              <PlusTabs />
            </Cell>
          )}
        </button>
        <AnimateHeight
          easing="cubic-bezier(.39,.11,.37,.99)"
          duration={200}
          height={isActive ? 'auto' : 0}
          onAnimationEnd={/* istanbul ignore next: todo: test */ () => onAnimationEnd(this.collapseRef)}>
          <Cell className={s.description}>
            <InfoSectionDescription description={description} index={index} />
          </Cell>
        </AnimateHeight>
      </li>
    );
  }
}
